/**
 * Removes non-TinyMCE data-* attributes from an HTML string.
 * Used to strip clipboard metadata (e.g. Jira/ProseMirror) that breaks translation parsing.
 */
export function removeHtmlDataAttributes(html: string): string {
    if (!html) {
        return html;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    removeDataAttributesFromElement(doc.body);

    return doc.body.innerHTML;
}

/**
 * Removes non-TinyMCE data-* attributes from a DOM subtree (root included).
 */
export function removeDataAttributesFromElement(root: Element): void {
    const clean = (el: Element): void => {
        Array.from(el.attributes).forEach((attr) => {
            if (attr.name.startsWith('data-') && !attr.name.startsWith('data-mce-')) {
                el.removeAttribute(attr.name);
            }
        });
    };

    clean(root);
    root.querySelectorAll('*').forEach(clean);
}
